"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = SearchInput;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _fieldAlert = require("./forms/field-alert");

var _forms = require("./forms");

var _iconButton = require("./buttons/icon-button");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _debounce = require("@react-hook/debounce");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "helpText", "id", "label", "onSearch", "placeholder"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var closeIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M17.625 6.187L6 17.812m12 0L6.375 6.187\"/></svg>";
var searchIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.2\" d=\"M13.8 14l8.9 6.9M13.55 5.25c-1.96-2.86-9.33-2.86-11.29 0-.63.92-.95 2.5-.95 4.75 0 2.24.31 3.82.94 4.74 1.89 2.77 9.35 2.95 11.29.11.63-.92.95-2.54.95-4.86 0-2.24-.31-3.82-.94-4.74z\"/></svg>";

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_forms.FormControlWrapper).withConfig({
  displayName: "search-input__StyledFormControlWrapper",
  componentId: "sc-1akgede-0"
})(["padding-right:48px;", " ", " *{outline:none;}&:hover{", "}"], (0, _styledTools.ifProp)('isAlertVisible', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('warning500'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _styles.color)('gray300'), (0, _styles.color)('gray300'))), (0, _styledTools.ifProp)('isAlertVisible', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('warning500'))));
/**
 * `StyledFormControl` styled component.
 */

var StyledFormControl = (0, _styledComponents["default"])(_forms.FormControl).withConfig({
  displayName: "search-input__StyledFormControl",
  componentId: "sc-1akgede-1"
})(["padding:7px 0 7px 14px;", " &::placeholder{color:", ";transition:color ", ";}&:disabled::placeholder{color:", ";}"], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 7px 0 7px 14px;\n  "]))), (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styles.color)('gray400'));
/**
 * `StyledIconButton` component.
 */

var StyledIconButton = (0, _styledComponents["default"])(_iconButton.IconButton).withConfig({
  displayName: "search-input__StyledIconButton",
  componentId: "sc-1akgede-2"
})(["color:", ";position:absolute;right:6px;top:2px;&:focus,&:hover{color:", ";}&:disabled{color:", ";}"], (0, _styles.color)('gray500'), (0, _styles.color)('gray900'), (0, _styles.color)('gray400'));
/**
 * Export `SearchInput` component.
 */

function SearchInput(props) {
  var className = props.className,
      disabled = props.disabled,
      helpText = props.helpText,
      id = props.id,
      label = props.label,
      onSearch = props.onSearch,
      placeholder = props.placeholder,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAlertVisible = _useState4[0],
      setAlertVisible = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      search = _useState8[0],
      setSearch = _useState8[1];

  var onSearchRef = (0, _react.useRef)(onSearch);
  var hasSearch = !(0, _isEmpty2["default"])(value);
  var handleDebouncedSearch = (0, _debounce.useDebounceCallback)((0, _react.useCallback)(function (search) {
    setSearch(search.trim());
  }, []), 500);
  var handleChange = (0, _react.useCallback)(function (event) {
    var inputValue = event.target.value;
    setValue(inputValue);
    handleDebouncedSearch(inputValue);
  }, [handleDebouncedSearch]);
  var handleKeyUp = (0, _react.useCallback)(function (event) {
    if (event.key === 'Enter') {
      setSearch(event.target.value.trim());
    }
  }, []);
  var handleSearch = (0, _react.useCallback)(function (event) {
    if (hasSearch) {
      event.preventDefault();
      setValue('');
      setSearch('');
      return;
    }

    return setAlertVisible(true);
  }, [hasSearch]);
  (0, _react.useEffect)(function () {
    onSearchRef.current = onSearch;
  });
  (0, _react.useEffect)(function () {
    if (onSearchRef.current) {
      onSearchRef.current(search);
    }
  }, [search]);
  return /*#__PURE__*/_react["default"].createElement(_forms.FormGroup, {
    disabled: disabled,
    hasAlert: isAlertVisible
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    className: className,
    disabled: disabled,
    hasError: false,
    hasFocus: hasFocus,
    isAlertVisible: isAlertVisible
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControl, _extends({}, rest, {
    "aria-label": label !== null && label !== void 0 ? label : translate('common.actions.search'),
    disabled: disabled,
    id: id !== null && id !== void 0 ? id : translate('common.actions.search'),
    onBlur: function onBlur() {
      setAlertVisible(false);
      setHasFocus(false);
    },
    onChange: handleChange,
    onFocus: function onFocus() {
      setAlertVisible(false);
      setHasFocus(true);
    },
    onKeyUp: handleKeyUp,
    placeholder: placeholder,
    value: value
  }))), /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    "aria-label": translate("common.actions.".concat(hasSearch ? 'clear' : 'search')),
    colorTheme: 'transparent',
    disabled: disabled,
    icon: hasSearch ? closeIcon24 : searchIcon24,
    iconSize: '24px',
    onClick: handleSearch
  }), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !isAlertVisible
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: isAlertVisible,
    type: 'warning'
  }, translate('searchInput.required')));
}